export enum adminApplicantsRegionsTypes {
  FETCH_ADMIN_APPLICANTS_REGIONS_REQUEST = "FETCH_ADMIN_APPLICANTS_REGIONS_REQUEST",
  FETCH_ADMIN_APPLICANTS_REGIONS_SUCCESS = "FETCH_ADMIN_APPLICANTS_REGIONS_SUCCESS",
  FETCH_ADMIN_APPLICANTS_REGIONS_FAILURE = "FETCH_ADMIN_APPLICANTS_REGIONS_FAILURE",
}